import Button from './Button.jsx';

const DesktopModal = ({ isOpen, title, message, button, fn }) => {
    if (!isOpen) return null;

    return (
        <div className="absolute top-1/4 left-1/4 z-10 w-1/2 rounded-3xl bg-[#1F293770] shadow-lg backdrop-blur-[10px]">
            <div className="p-4">
                <h2 className="mb-0 text-lg font-bold">{title}</h2>
            </div>
            <div className="p-4" dangerouslySetInnerHTML={{ __html: message }} />
            <div className="flex justify-center p-4">{button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}</div>
        </div>
    );
};
export default DesktopModal;
